import theme from '@theme';
import styled from 'styled-components';

const BodyContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: start;
  align-items: start;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${theme.palette.grey[100]};
`;

export default BodyContainer;
